module.exports = __webpack_public_path__ + "img/smartphone.d03b32f7.png";